



































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Timer } from '~/mixins';

@Component
export default class CountdownTimer extends Mixins(Timer) {
  @Prop(Number) endTime!: number;
  @Prop(Boolean) large!: boolean;
  @Prop({ type: String, default: '18px' }) fontSize!: string;
  @Prop({ type: String, default: 'inherit' }) color!: string;
  @Prop({ type: Boolean, default: true }) alwaysShow!: boolean;

  mounted() {
    this.beginTimer(this.endTime);
  }
}
